<template>
  <div>
    <div class="row">
      <h6 class="heading-small text-muted mb-4 pl-2">
        <i :class="[icon, 'mr-1']"></i> {{ title }}
      </h6>
    </div>
    <div v-if="!data.length" class="text-center text-warning mb-3 mt--2">
      {{ emptyMessage }}
    </div>
    <div class="row vld-parent" ref="list_open_tasks">
      <div
        class="col-lg-3 col-md-6"
        v-for="task in data"
        :key="'task_' + task.id"
        @click="handleViewTask(task.id)"
      >
        <span title="Ver tarefa" class="task-card pb-1">
          <div class="mb-3 task-card-header">
            <i class="fas fa-clipboard-list"></i>
            <span :title="task.title">{{ task.title }}</span>
          </div>
          <span class="text-sm text-muted ml-0"
            ><b class="font-weight-bold">{{ task.responses.length }}</b>
            respostas</span
          >
          <span class="float-right text-sm text-muted" v-if="!showDeadline"
            ><i class="far fa-calendar-alt mr-1"></i> início em
            {{ formatDate(task.start_date, "L") }}</span
          >
          <span class="float-right text-sm text-muted" v-else-if="task.deadline"
            ><i class="far fa-calendar-alt mr-1"></i> até
            {{ formatDate(task.deadline, "L") }}</span
          >
          <span class="float-right text-sm text-muted" v-else
            ><i class="far fa-calendar-alt mr-1"></i> sem prazo</span
          >
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "task-list",
  props: {
    data: {
      type: Array,
      default: () => [],
      description: "List of tasks",
    },
    title: {
      type: String,
      required: true,
      description: "Section title",
    },
    icon: {
      type: String,
      default: "fas fa-clipboard-list",
      description: "Section icon",
    },
    emptyMessage: {
      type: String,
      default: "Não há tarefas no momento",
      description: "Message displayed when listTasks is empty",
    },
    showDeadline: {
      type: Boolean,
      default: true,
      description:
        "If the task card should show the deadline or the task start date",
    },
  },
  data() {
    return {
      clicked: false,
    };
  },
  methods: {
    handleViewTask(taskId) {
      if (this.clicked) return;
      this.clicked = true;
      this.$router.push(
        `/admin/batches/${this.$route.params.id}/acompanhamento/tarefas/${taskId}/editar`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.2rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: flex;
  }

  .task-card-header i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: middle;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}
</style>
